export default "__VITE_ASSET__yBylUwU4__"